import { PayloadAction } from "@reduxjs/toolkit"
import { GroupsState } from "../../models/GroupsState"
import { GetStudentsListForGroupPayload } from "../../payload/GetStudentsListForGroup/GetStudentsListForGroupPayload";

const getStudentsListForGroupFetch = (state: GroupsState, action: PayloadAction<GetStudentsListForGroupPayload>) => {
    state.isLoading = true
}

export default getStudentsListForGroupFetch;